import React from "react";
import ComplianceGrid from "./ComplianceGrid";
import TrailerLayout from "./TrailerLayout";
import { withUserProfile } from "../../../../userProfile/userProfileContext";
import { getDataWithQueryString } from "../../../../api/componentAPIs";
import Events from "../../../../utilities/EventEmitter";
import { getUTCDate } from '@dataGrid/gridUtilities';
import { isValid as isDateTimeValid, format } from "date-fns";
class DockCompliance extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeSection: 0,
      complianceData: null,
      selectedPlannedRoute: null,
      selectedDispatchedRoute: null,
      manifestNumber: null,
      planDate: null,
    };
    this.terminalCode = this.props.userData.userProfile.terminal.code;
    this.DOCK_COMPLIANCE_DATE_FORMAT = "yyyy-MM-dd";
  }

  componentDidMount() {
    this._isComponentMounted = true;
    this.getLatestReportDate();
  }

  componentWillUnmount() {
    this._isComponentMounted = false;
  }

  componentDidUpdate() {
    if (this.terminalCode !== this.props.userData.userProfile.terminal.code) {
      this.terminalCode = this.props.userData.userProfile.terminal.code;
      this.getLatestReportDate();
    }
  }

  getLatestReportDate = () => {
    getDataWithQueryString(
      "GetDockComplianceLatestReportDate",
      `terminalCode=${this.terminalCode}`
    ).then((response) => {
      if (response.status === 200) {
        const planDate =
          response.data.latestDCReportDate ??
          this.props.userData.userProfile.planDate;
        this.updateDate(planDate);
      } else {
        this.updateDate(this.props.userData.userProfile.planDate);
      }
    });
  };

  getDockCompliance = (planDate) => {
    getDataWithQueryString(
      "GetDockComplianceReport",
      `planDate=${planDate}&terminalCode=${this.terminalCode}`
    ).then(
      (response) => {
        if (this._isComponentMounted) {
          if (response.status === 200) {
            this.setState({
              complianceData: response.data,
              activeSection: 0,
            });
            Events.emit("getComplianceKPI", planDate, this.terminalCode);
          } else {
            this.setState({
              complianceData: [],
              activeSection: 0,
            });
          }
        }
      },
      (error) => {
        if (this._isComponentMounted) {
          this.setState({
            complianceData: [],
            activeSection: 0,
          });
        }
      }
    );
  };

  goBack = () => {
    this.setState((state) => ({
      activeSection: state.activeSection - 1,
    }));
  };

  onRouteSelected = (route) => {
    this.setState({
      activeSection: 1,
      selectedPlannedRoute: route.plannedRoute,
      selectedDispatchedRoute: route.dispatchedRoute,
      manifestNumber: route.manifestNumber,
    });
  };

  formatPlanDate = (planDate) =>
    format(getUTCDate(planDate), this.DOCK_COMPLIANCE_DATE_FORMAT);

  updateDate = (planDate) => {
    const formattedPlanDate = this.formatPlanDate(planDate);
    this.setState({
      planDate: formattedPlanDate,
    });
    this.getDockCompliance(formattedPlanDate);
  };

  onDateChanged = (value) => {
    if (
      value &&
      isDateTimeValid(value) &&
      this.formatPlanDate(value) !== this.state.planDate
    ) {
      this.updateDate(value);
    }
  };

  renderSection = (activeSection) => {
    if (activeSection <= 0) {
      return (
        <ComplianceGrid
          planDate={this.state.planDate}
          onDateChanged={this.onDateChanged}
          complianceData={this.state.complianceData}
          onSelected={this.onRouteSelected}
          selectedPlannedRoute={this.state.selectedPlannedRoute}
          selectedDispatchedRoute={this.state.selectedDispatchedRoute}
        />
      );
    } else if (activeSection === 1) {
      return (
        <TrailerLayout
          goBack={this.goBack}
          selectedPlannedRoute={this.state.selectedPlannedRoute}
          manifestNumber={this.state.manifestNumber}
          planDate={this.state.planDate}
          terminalCode={this.terminalCode}
        />
      );
    }
  };

  render() {
    return this.renderSection(this.state.activeSection);
  }
}

export default withUserProfile(DockCompliance);
